<div class="pt-3 pb-2 mb-3">
	<div class="shadow-lg p-3 mb-5 bg-white rounded table-responsive">
		<table *ngIf="audits" class="table table-hover">
			<thead>
				<tr>
					<th>Process</th>
					<th>Tx ID</th>
					<th>ID</th>
					<th>Step</th>
					<th>Action</th>
					<th>Created At</th>
					<th>Error</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let row of audits" [ngClass]="{ 'group-a': row.groupIndex % 2 === 0, 'group-b': row.groupIndex % 2 !== 0 }">
					<td *ngIf="row.addToRow" [attr.rowspan]="getRowCount(row.txId)">{{row.process}}</td>
					<td *ngIf="row.addToRow" [attr.rowspan]="getRowCount(row.txId)">{{row.txId}}</td>
					<td>{{row.id}}</td>
					<td>{{row.step}}</td>
					<td>{{row.action}}</td>
					<td>{{row.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
					<td>{{row.error}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
